module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/price_location-0c5628baafaa55aef969f4a738d90d55.jpg";